import { cn } from '@/utils/cn'

interface SkeletonProps {
  className?: string
  /** Marks a text line so tests and tooling can count them. */
  line?: boolean
}

/**
 * One placeholder block. Compose several to mirror the shape of the content that
 * will arrive (loading-states: skeleton over spinner when the shape is known).
 */
export function Skeleton({ className, line }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-line={line ? '' : undefined}
      className={cn('block rounded bg-surface-bg animate-pulse', className)}
    />
  )
}
